if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"minerva","remotes":[{"alias":"menu","name":"menu","entry":"https://concentrixcx.azureedge.net/dev/react-module/menu/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(8(58|79|88)|12|339|629|656)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}